// extracted by mini-css-extract-plugin
module.exports = {"table":"ProductTable_table__2W6uw","loading":"ProductTable_loading__2Cnxg"};